import { z, ZodType } from "zod";
import { baseRoute } from "./auction";
import api from "@/lib/axiosConfig";

export const auctionSchema = z.object({
  id: z.string().optional(),

  ventesDescriptionNumeroVente: z.string().nonempty("form.error.emptyField"),
  ventesDescriptionTitre: z.string(),
});

export const appendNoDuplicateSaleNumbersRefine = <
  T extends {
    id?: string;
    ventesDescriptionNumeroVente: string;
  },
>(
  schema: ZodType<T>,
) =>
  schema.refine(
    async (val) =>
      await validateNoDuplicateSaleNumbers(
        val.ventesDescriptionNumeroVente,
        val.id,
      )
        .then(() => true)
        .catch(() => false),
    {
      message: "form.error.auction.duplicateSaleNumbers",
      path: ["ventesDescriptionNumeroVente"],
    },
  );

export async function validateNoDuplicateSaleNumbers(
  saleNumber: string,
  id?: string,
) {
  await api.get<void>(
    `${baseRoute}${id ? `/${id}` : ""}/sale-number/validate/no-duplicates`,
    {
      params: {
        value: saleNumber,
      },
    },
  );
}
